import { fork, put, takeEvery } from "typed-redux-saga";
import { ApplicationActionTypes as ComponentAdvosysApplicationActionTypes } from "@advosys/component-advosys-react";
import { errorHandlerActions } from "./components/main-layout/components/error-handler-store";
function* handleFail(action) {
    yield* put(errorHandlerActions.showError(action.payload.errorMessage));
}
function* watchComponentAdvosysFail() {
    yield* takeEvery(ComponentAdvosysApplicationActionTypes.ApplicationFail, handleFail);
}
export const applicationSagaInit = () => [fork(watchComponentAdvosysFail)];
